
import { RawEmailData, EmailSummaryForHook } from "../types";

export const mapRawEmailToEnhancedEmailSummary = (email: RawEmailData): EmailSummaryForHook & {
  sentimentConfidence?: number;
  emotionalTone?: string;
  responseUrgency?: string;
  relationshipHealthScore?: number;
  smartNextSteps?: any[];
  contextAnalysis?: any;
  businessRelevanceScore?: number;
  isSpam?: boolean;
  spamConfidence?: number;
  contentClassification?: any;
} => {
  // Parse assignedTo safely
  let assignedTo = null;
  if (email.assignedto) {
    try {
      if (typeof email.assignedto === 'string') {
        assignedTo = JSON.parse(email.assignedto);
      } else {
        assignedTo = email.assignedto;
      }
    } catch (e) {
      console.warn('Failed to parse assignedTo:', e);
    }
  }

  return {
    id: email.id,
    subject: email.subject,
    sender: email.sender,
    receivedAt: new Date(email.received_at),
    summary: email.summary,
    assignedTo: assignedTo,
    link: email.link,
    nextSteps: email.next_steps || [],
    is_archived: email.is_archived,
    is_flagged: email.is_flagged,
    updated_at: email.updated_at ? new Date(email.updated_at) : undefined,
    categories: email.categories || [],
    tags: email.tags || [],
    processing_status: email.processing_status || 'pending',
    provider_message_id: email.provider_message_id,
    provider_thread_id: email.provider_thread_id,
    email_direction: email.email_direction || 'incoming', // Default to incoming for backward compatibility
    extractedEntities: email.extracted_entities as Record<string, any> | null,
    sentiment: email.sentiment,
    priorityScore: email.ai_priority_score,
    
    // Enhanced fields with defaults
    sentimentConfidence: 0.8,
    emotionalTone: email.sentiment || 'neutral',
    responseUrgency: email.ai_priority_score && email.ai_priority_score > 7 ? 'high' : 'medium',
    relationshipHealthScore: Math.random() * 100, // Placeholder
    smartNextSteps: email.next_steps?.map(step => ({ action: step, confidence: 0.8 })) || [],
    contextAnalysis: {
      isFollowUp: email.subject.toLowerCase().includes('re:'),
      mentionsDeadline: /deadline|urgent|asap/i.test(email.summary),
      requiresAction: email.next_steps && email.next_steps.length > 0
    },
    businessRelevanceScore: email.ai_priority_score || 5,
    isSpam: false, // Will be enhanced by AI processing
    spamConfidence: 0.1,
    contentClassification: {
      type: email.email_direction === 'outgoing' ? 'outbound_communication' : 'inbound_inquiry',
      confidence: 0.9
    }
  };
};
